<template>
  <div>
    <page-heading :title="$t(`${translationPrefix}.title`)" :loading="fetching">
      <template slot="buttons">
        <router-link :to="{ name: 'timesheets' }"><el-button type="info">All Timesheets</el-button></router-link>
      </template>
    </page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else>
      <div slot="header">
        All Archived Timesheets
      </div>
      <timesheets-list :timesheets="archivedTimesheets"></timesheets-list>
    </el-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import TimesheetsList from '@/components/timesheet/TimesheetsListByUser';

  export default {
    name: 'TimesheetsArchivePage',
    components: {
      timesheetsList: TimesheetsList,
    },
    created() {
      this.fetchTimesheets({ status: 'archived' });
    },
    data() {
      return {
        translationPrefix: 'pages.timesheetsArchive',
      };
    },
    computed: {
      ...mapGetters('entities/timesheets', ['fetching']),
      archivedTimesheets() {
        return this.$store.getters['entities/timesheets/query']()
          .with('user.profile')
          .where(record => record.status === 'archived')
          .get();
      },
    },
    methods: {
      ...mapActions('entities/timesheets', ['fetchTimesheets']),
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/TimesheetsArchive.vue